/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [authorization-reducer.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 11.09.18 12:07
 */

import {
    FETCH_CONFIGURATION,
    LOGIN_ANONYMOUS,
    LOGIN_CONNECT,
    LOGIN_FAILURE,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    loginStatus,
    LOGOUT_REQUEST,
    UPDATE_LOGINDATA,
} from "../../actions";
import {getBearer, getLocalSiteConfiguration, getUserSettings, saveBearer} from "../../actions/local-storage";
import {FREE_MEMBERSHIP, LOCAL_MEDIA_RESIZE, LOCAL_MEDIA_SLIDER} from "../../actions/spaces";
import {getPublicUser} from "../../actions/environment";

const bearer = getBearer();
const initial = bearer ? {
    status: loginStatus.CONNECT, principal: {
        username: bearer.username,
        avatar: bearer.avatar,
        firstname: bearer.firstname,
        lastname: bearer.lastname,
        isSuperUser: bearer.isSuperUser,
        isAdmin: bearer.isAdmin,
        membership: bearer.membership,
    },
    isAuthorized: true
} : {
    status: loginStatus.ANONYMOUS, principal: {
        username: getPublicUser(),
        avatar: null,
        firstname: 'Not logged in',
        lastname: 'Not logged in',
        isSuperUser: false,
        isAdmin: false,
        membership: FREE_MEMBERSHIP,
    },
    isAuthorized: false
};

// temporary update as long as user does not log in again - avatar, firstname and lastname only!
const updateBearer = (user) => {
    if (!user) return null;
    const bearer = getBearer();
    bearer.avatar = user.avatar;
    bearer.firstname = user.firstname;
    bearer.lastname = user.lastname;
    bearer.membership= user.membership;
    saveBearer(bearer);
    return bearer;
}

export default function (state = initial, action) {

    switch (action.type) {
        case LOGIN_REQUEST:
            return {status: loginStatus.REQUEST, principal: null, isAuthorized: false};

        case LOGIN_SUCCESS:
            return {status: loginStatus.SUCCESS, principal: action.principal, isAuthorized: true};

        case LOGIN_FAILURE:
            return {status: loginStatus.ERROR, principal: null, isAuthorized: false, error: action.error};

        case LOGOUT_REQUEST:
            return {status: loginStatus.LOGOUT, principal: null, isAuthorized: false};

        case LOGIN_CONNECT:
            return {...state, status: loginStatus.SUCCESS, isAuthorized: true};

        case LOGIN_ANONYMOUS:
            return {status: loginStatus.ANONYMOUS, principal: action.principal, isAuthorized: false};

        case UPDATE_LOGINDATA:
            const bearer = updateBearer(action.logindata.user);
            const principal = {
                ...state.principal,
                avatar: bearer.avatar,
                firstname: bearer.firstname,
                lastname: bearer.lastname,
                membership: bearer.membership,
            }
            return {...state, principal: principal}

        // case LOGIN_VALIDATE:
        //     nothing

        default:
            return state;
    }
}

/* configuration coming from server */
export function ConfigurationReducer(state = null, action) {

    switch (action.type) {
        case FETCH_CONFIGURATION:
            return action.configuration ? action.configuration : getLocalSiteConfiguration();

        default:
            return state;
    }
}

/* user settings coming from local storage */
export function LocalConfigReducer(state = {status: 'refresh', config: getUserSettings()}, action) {
    switch (action.type) {

        case LOCAL_MEDIA_RESIZE:
            return {status: 'update', config: action.localconfig};

        case LOCAL_MEDIA_SLIDER:
            return {status: 'slider', config: action.localconfig};

        default:
            return state;
    }
}